/**
 * Cookie name constants for Stytch session management.
 *
 * Import these constants instead of hard-coding cookie name strings in any file
 * that reads or writes Stytch session cookies.
 */

/** The Stytch session JWT cookie (readable by JavaScript, used for claim extraction). */
export const STYTCH_SESSION_JWT_COOKIE = 'stytch_session_jwt'

/**
 * The Stytch opaque session token cookie (HTTP-only in production).
 * Used by the Stytch SDK's `session.updateSession` for server-side authentication.
 */
export const STYTCH_SESSION_OPAQUE_COOKIE = 'stytch_session'

export const SESSION_JWT_FAILURE_REASONS = [
  'cookie_missing',
  'project_id_missing',
  'jwt_invalid',
  'subject_missing',
] as const

export type SessionJwtFailureReason = (typeof SESSION_JWT_FAILURE_REASONS)[number]

export type SessionJwtValidationFailureReason = Exclude<SessionJwtFailureReason, 'subject_missing'>
